module.exports = __webpack_public_path__ + "static/media/logos.f2aa75ca.svg";